// AI Upgraded Component
import { Component, Input } from '@angular/core';
import { ExportService } from '@client/ng2/core/services/export.service';
import { SessionService } from '@monsido/core/session/session.service';
import { TranslateService } from '@monsido_services/services/mon-translate/dist/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { CsvExportsOverlayComponent } from '../overlay/csv-exports.component';
import { MON_EVENTS } from '@monsido/ng2/core/constants/mon-events.constant';

@Component({
    selector: 'csv-export-dialog',
    templateUrl: './dialog.component.html',
    standalone: false,
})
export class CsvExportDialogComponent {
    @Input() exports: any[] = [];
    @Input() monDialogId!: number;

    params: any = {};
    startExportTxt: string = this.translateService.getString('Start export');
    onDownload: boolean = false;
    downloadDone: boolean = false;
    confirm: boolean = false;
    modify: boolean = false;

    constructor (
        private readonly exportService: ExportService,
        private readonly sessionService: SessionService,
        private readonly translateService: TranslateService,
        private readonly monEventService: MonEventService,
    ) {}

    goToExports (): void {
        this.monEventService.remove(this.monDialogId);
        const dialogParams = {
            component: CsvExportsOverlayComponent,
            dialogOptions: {
                size: 'md',
            },
        };
        this.monEventService.run(MON_EVENTS.CLOSE_ALL_OVERLAY_DIALOGS);
        this.monEventService.run(MON_EVENTS.LOAD_NG2_DIALOG, dialogParams);
    }

    download (exportParams: any, index: number): void {
        const isValidExportsInputsArray = Array.isArray(this.exports) &&
                this.exports[index] &&
                Array.isArray(this.exports[index].inputs) &&
                this.exports[index].inputs.length > 0;

        const params = {
            recipients: [this.sessionService.me?.email],
        } as any;

        Object.keys(exportParams).forEach((key) => {
            params[key] = exportParams[key];
        });

        if (params.date) {
            params.category_ref =
                params.date.startDate.format('YYYY-MM-DD') +
                ',' +
                params.date.endDate.format('YYYY-MM-DD') +
                ',' +
                (params.category_ref < 1000 ? params.category_ref : 1000);
        }

        if (isValidExportsInputsArray) {
            params.category_ref =
                    params.date.startDate.format('YYYY-MM-DD') +
                    ',' +
                    params.date.endDate.format('YYYY-MM-DD') +
                    ',' +
                    (this.exports[index].inputs[0].default < 1000 ? this.exports[index].inputs[0].default : 1000);
        }

        if (!params.isGlobalExport) {
            if (this.sessionService.domainGroup) {
                params.source_type = 'DomainGroup';
                params.source_id = this.sessionService.domainGroup.id;
            } else if (this.sessionService.domain) {
                params.source_type = 'Domain';
                params.source_id = this.sessionService.domain.id;
            }

            if (!params.source_type) {
                delete params.source_type;
            }

            if (!params.source_id) {
                delete params.source_id;
            }
        }
        this.onDownload = true;
        this.params = params;
        this.exportService.create(params)
            .toPromise()
            .then(() => {
                this.onDownload = false;
                this.downloadDone = true;
            });
    }

    modifyDefaultExportNumber (): void {
        this.modify = true;
        this.confirm = false;
    }
}
